import React from "react"
import { Container } from "react-bootstrap"

export const ContentBox = (props) => {
    return (
        <div style={{
                border: "2px"
                , borderStyle: "solid"
                // , borderColor: "#3296FA"
                , borderColor: "black"
                , borderRadius: "15px"
                // , padding: "25px"
                , paddingTop: '4px'
                , paddingBottom: "7px"
            }}
        >
            <Container>
            {props.children}
            </Container>
        </div>
    )
}